import { ItineraryBookData } from './itinerary.interfaces';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const market: Market = getCurrentMarketSpecs();
const Currency = market.moneyFormat.currency;

const OneSegmentWithOneStop: ItineraryBookData = {
    Legs: [
        {
            Segments: [
                {
                    ArrivalAirportCode: 'PMI',
                    ArrivalAirportName: 'Palma Mallorca',
                    ArrivalAirportLabel: 'Palma de Mallorca',
                    ArrivalDate: '2024-01-25T09:50:00.0000000',
                    ArrivalLocationName: null,
                    CabinClass: 1,
                    CompanyLogo: 'https://www.sembo.se/d/Images/flight/airlines/SK.gif',
                    DepartureAirportCode: 'ARN',
                    DepartureAirportName: 'Arlanda Stockholm',
                    DepartureAirportLabel: 'Stockholm Arlanda',
                    DepartureDate: '2024-01-25T06:10:00.0000000',
                    DepartureLocationName: null,
                    FlightNumber: 'SK 1805',
                    FlightTime: '3h 40m',
                    HasTechnicalStop: true,
                    MarketingCarrier: 'SK',
                    MarketingCarrierLogoUrl: null,
                    MarketingCarrierName: 'SAS',
                    OperatingCarrier: null,
                    OperatingCarrierName: null,
                    StopOverTime: '',
                },
            ],
            IncludedBaggage: {
                Cabin: {
                    Pieces: 1,
                    WeightPerPiece: 0,
                    TotalWeight: 0,
                    LimitedInfo: false,
                    AtLeastOneBagIncluded: false,
                },
                CheckedIn: {
                    Pieces: 0,
                    WeightPerPiece: 0,
                    TotalWeight: 0,
                    LimitedInfo: false,
                    AtLeastOneBagIncluded: false,
                },
            },
            PlatingCarrier: 'SK',
            PlatingCarrierName: 'SAS',
            PlatingCarrierLogo: 'https://www.sembo.se/d/Images/flight/airlines/SK.gif',
            TravelTime: '3h 40m',
        },
        {
            Segments: [
                {
                    ArrivalAirportCode: 'MUC',
                    ArrivalAirportName: 'Munchen',
                    ArrivalAirportLabel: 'Munchen',
                    ArrivalDate: '2024-01-27T10:10:00.0000000',
                    ArrivalLocationName: null,
                    CabinClass: 1,
                    CompanyLogo: 'https://www.sembo.se/d/Images/flight/airlines/EW.gif',
                    DepartureAirportCode: 'PMI',
                    DepartureAirportName: 'Palma Mallorca',
                    DepartureAirportLabel: 'Palma de Mallorca',
                    DepartureDate: '2024-01-27T08:00:00.0000000',
                    DepartureLocationName: null,
                    FlightNumber: 'EW 6890',
                    FlightTime: '2h 10m',
                    HasTechnicalStop: false,
                    MarketingCarrier: 'EW',
                    MarketingCarrierLogoUrl: null,
                    MarketingCarrierName: 'Eurowings',
                    OperatingCarrier: 'E6',
                    OperatingCarrierName: 'Bringer Air Cargo',
                    StopOverTime: '2 h 0 min',
                },
                {
                    ArrivalAirportCode: 'ARN',
                    ArrivalAirportName: 'Arlanda Stockholm',
                    ArrivalAirportLabel: 'Stockholm Arlanda',
                    ArrivalDate: '2024-01-27T14:25:00.0000000',
                    ArrivalLocationName: null,
                    CabinClass: 1,
                    CompanyLogo: 'https://www.sembo.se/d/Images/flight/airlines/LH.gif',
                    DepartureAirportCode: 'MUC',
                    DepartureAirportName: 'Munchen',
                    DepartureAirportLabel: 'Muchen',
                    DepartureDate: '2024-01-27T12:10:00.0000000',
                    DepartureLocationName: null,
                    FlightNumber: 'LH 2416',
                    FlightTime: '2h 15m',
                    HasTechnicalStop: false,
                    MarketingCarrier: 'LH',
                    MarketingCarrierLogoUrl: null,
                    MarketingCarrierName: 'Lufthansa',
                    OperatingCarrier: null,
                    OperatingCarrierName: null,
                    StopOverTime: '',
                },
            ],
            IncludedBaggage: {
                Cabin: {
                    Pieces: 0,
                    WeightPerPiece: 0,
                    TotalWeight: 0,
                    LimitedInfo: false,
                    AtLeastOneBagIncluded: false,
                },
                CheckedIn: {
                    Pieces: 2,
                    WeightPerPiece: 0,
                    TotalWeight: 0,
                    LimitedInfo: false,
                    AtLeastOneBagIncluded: false,
                },
            },
            PlatingCarrier: 'LH',
            PlatingCarrierName: 'Lufthansa',
            PlatingCarrierLogo: 'https://www.sembo.se/d/Images/flight/airlines/LH.gif',
            TravelTime: '6h 25m',
        },
    ],
    BookLink:
        'https://www.sembo.se/d/Booking/Put_In_Basket.aspx?itineraryId=H4sIAAAAAAAEAI1TTWvjMBDNXsrC_gmjs0MlxXZs38o2JaUfLNstPZQ9KLacirq2kdSkEPLDe9qdkZ1EDbtQX_Q0Hr15ejMafRmNRn_gwxW_EwTvXzfEyCXJH2EVJckJZac8PuWURwHN8pjmlJKQmAJ-3V0hKo-zkpztsqrGpQUspTHugZicy05o-6qlS1AQOft5i9gi_nFz6eiR_755btp1Q7ahL2bal4EazBcze_ggZsiiKaT4YmYPQZJmdCfmTGu1EvVeylDeSbm5__5JKVHOY0_K9fxfUhg_8uV6HvCIJf-TMpS3nkMfpfwOSach8EuLlay7VlvIAW_FiyE5yFQoICpFnIH9Y8E5G0c0S8Ypy-i4EBmjNKkmsmBwTEAqrosWwIWoDXanwCiueBFcawCyQOS48YCTdDfDSSgHjLDyaORbT1OBLHLb6rVcKtGEwUG3w41BKKxqm_nrAvLVUF4N5ZVeeKzt2t-gX9IKhAcV1mJKrZZP6EzbFd6Jzsfw4xHc1L1jlDK8mTGln2MGL2rj9SAktVwa91q8SfYH2R49DrqfR2l7xs4qsy-E8-UNot_8HdP0k0xwodWTs27rrrshAi_NsmSCDcczbMJx_AoXT9IpYoxPmfPbC6tD2GJ4wtPM8WpZIjWuzj3Sx0zRwgPfb5VZQ29RjTuEjdkQW9WH_my33_4CstqB8ZIEAAA.\u0026type=flight',
    BookPrice: {
        Amount: 3289,
        Currency,
    },
    RebookableBookLink:
        'https://www.sembo.se/d/Booking/Put_In_Basket.aspx?itineraryId=H4sIAAAAAAAEAI1TPW_bMBB1lqJA_oTAWUZIWpIlbUHrwkXjoGgaZAg60BLlEFUlgaTtAob_d7bkjpJtxmiBaLnH0_Hduw-OLkaj0Qt8aPH7gOD5444YuSL5I1hRkpxQdsXjK055FNAsj2lOKQmJKeDX3TdE5XlUkrNDVNW4sIClNMYzEJPPshParrV0AQo81z9uEVvE3xdfHT3y3ze_m3bbkH3oi5n2aSAH88XMHt6IGaJoCiG-mNlDkKQZPYi51lptRH2UMqR3Uhb3n94pJcp57Em5mf9LCuNnfbmZBzxiyf-kDOmt16G3Un6FpNPg-KnFRtZdqy3EQG_FH0NykKlQQFSKOIP2jwXnbBzRLBmnLKPjQmSM0qSayILBNQGhaJctgC-iNjidAr1osRC0NQBZIHLceMFJupvhJpQDRlh5NPJvT1OBLHLb6q1cKdGEwUm3w41BKKxqm_l6CfFqSK-G9EovXbVrJG23XgYUvZBWIDyJsBZDarV6wsa0XeHd6HwMPx6hmbpvGKUMCzOm9GPM0IraeCMISS1Xxj0Wb5H9PbZnb4Me11HanrGzyhwT4Xp5e-jP_sA0fScTFLR5cp3bu3J3RGDRLEsmOG-8wyYct69w_iSdIkb_lLl2e251clt0T3iaOV4tS6RG67pHep8pWnjfx6MyWxgtqnGXcDA7Yqv6NJ_9_vIVXGm6RJEEAAA.\u0026type=flight',
    RebookableBookPrice: {
        Amount: 3888.0,
        Currency,
    },
    Adults: 1,
    Children: 0,
    Infants: 0,
    BookItineraryId:
        'H4sIAAAAAAAEAI1TTWvjMBDNXsrC_gmjs0MlxXZs38o2JaUfLNstPZQ9KLacirq2kdSkEPLDe9qdkZ1EDbtQX_Q0Hr15ejMafRmNRn_gwxW_EwTvXzfEyCXJH2EVJckJZac8PuWURwHN8pjmlJKQmAJ-3V0hKo-zkpztsqrGpQUspTHugZicy05o-6qlS1AQOft5i9gi_nFz6eiR_755btp1Q7ahL2bal4EazBcze_ggZsiiKaT4YmYPQZJmdCfmTGu1EvVeylDeSbm5__5JKVHOY0_K9fxfUhg_8uV6HvCIJf-TMpS3nkMfpfwOSach8EuLlay7VlvIAW_FiyE5yFQoICpFnIH9Y8E5G0c0S8Ypy-i4EBmjNKkmsmBwTEAqrosWwIWoDXanwCiueBFcawCyQOS48YCTdDfDSSgHjLDyaORbT1OBLHLb6rVcKtGEwUG3w41BKKxqm_nrAvLVUF4N5ZVeeKzt2t-gX9IKhAcV1mJKrZZP6EzbFd6Jzsfw4xHc1L1jlDK8mTGln2MGL2rj9SAktVwa91q8SfYH2R49DrqfR2l7xs4qsy-E8-UNot_8HdP0k0xwodWTs27rrrshAi_NsmSCDcczbMJx_AoXT9IpYoxPmfPbC6tD2GJ4wtPM8WpZIjWuzj3Sx0zRwgPfb5VZQ29RjTuEjdkQW9WH_my33_4CstqB8ZIEAAA.',
    RebookableItineraryId:
        'H4sIAAAAAAAEAI1TPW_bMBB1lqJA_oTAWUZIWpIlbUHrwkXjoGgaZAg60BLlEFUlgaTtAob_d7bkjpJtxmiBaLnH0_Hduw-OLkaj0Qt8aPH7gOD5444YuSL5I1hRkpxQdsXjK055FNAsj2lOKQmJKeDX3TdE5XlUkrNDVNW4sIClNMYzEJPPshParrV0AQo81z9uEVvE3xdfHT3y3ze_m3bbkH3oi5n2aSAH88XMHt6IGaJoCiG-mNlDkKQZPYi51lptRH2UMqR3Uhb3n94pJcp57Em5mf9LCuNnfbmZBzxiyf-kDOmt16G3Un6FpNPg-KnFRtZdqy3EQG_FH0NykKlQQFSKOIP2jwXnbBzRLBmnLKPjQmSM0qSayILBNQGhaJctgC-iNjidAr1osRC0NQBZIHLceMFJupvhJpQDRlh5NPJvT1OBLHLb6q1cKdGEwUm3w41BKKxqm_l6CfFqSK-G9EovXbVrJG23XgYUvZBWIDyJsBZDarV6wsa0XeHd6HwMPx6hmbpvGKUMCzOm9GPM0IraeCMISS1Xxj0Wb5H9PbZnb4Me11HanrGzyhwT4Xp5e-jP_sA0fScTFLR5cp3bu3J3RGDRLEsmOG-8wyYct69w_iSdIkb_lLl2e251clt0T3iaOV4tS6RG67pHep8pWnjfx6MyWxgtqnGXcDA7Yqv6NJ_9_vIVXGm6RJEEAAA.',
    ResultPageLink:
        'https://www.sembo.se/d/flight/flights.aspx?identifier=H4sIAAAAAAAEAI1TTWvjMBDNXsrC_gmjs0MlxXZs38o2JaUfLNstPZQ9KLacirq2kdSkEPLDe9qdkZ1EDbtQX_Q0Hr15ejMafRmNRn_gwxW_EwTvXzfEyCXJH2EVJckJZac8PuWURwHN8pjmlJKQmAJ-3V0hKo-zkpztsqrGpQUspTHugZicy05o-6qlS1AQOft5i9gi_nFz6eiR_755btp1Q7ahL2bal4EazBcze_ggZsiiKaT4YmYPQZJmdCfmTGu1EvVeylDeSbm5__5JKVHOY0_K9fxfUhg_8uV6HvCIJf-TMpS3nkMfpfwOSach8EuLlay7VlvIAW_FiyE5yFQoICpFnIH9Y8E5G0c0S8Ypy-i4EBmjNKkmsmBwTEAqrosWwIWoDXanwCiueBFcawCyQOS48YCTdDfDSSgHjLDyaORbT1OBLHLb6rVcKtGEwUG3w41BKKxqm_nrAvLVUF4N5ZVeeKzt2t-gX9IKhAcV1mJKrZZP6EzbFd6Jzsfw4xHc1L1jlDK8mTGln2MGL2rj9SAktVwa91q8SfYH2R49DrqfR2l7xs4qsy-E8-UNot_8HdP0k0xwodWTs27rrrshAi_N0mSCDcczbMJx_AoXT9IpYoxPmfPbC6tD2GJ4wtLM8WpZIjWuzj3Sx0zRwgPfb5VZQ29RjTuEjdkQW9WH_my33_4CfwL3R5IEAAA.\u0026showAllResults=true\u0026external=1\u0026agencyNumber=40011\u0026affiliateId=40011\u0026nsf=true\u0026udm=true\u0026utm_source=Kayak (SE)\u0026utm_medium=Meta\u0026urlType=book',
    NonRebookablePriceBreakdown: {
        FareTypes: [
            {
                FareType: 1,
                NumberOfPax: 2,
                FlightPrice: {
                    Amount: 651.60064166666666666666666667,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 1238,
                    Currency,
                },
                BookingFee: {
                    Amount: -28.600641666666666666666666667,
                    Currency,
                },
                TotalPrice: {
                    Amount: 1861,
                    Currency,
                },
            },
            {
                FareType: 2,
                NumberOfPax: 1,
                FlightPrice: {
                    Amount: 484.60064166666666666666666667,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 1238,
                    Currency,
                },
                BookingFee: {
                    Amount: -28.600641666666666666666666667,
                    Currency,
                },
                TotalPrice: {
                    Amount: 1694,
                    Currency,
                },
            },
            {
                FareType: 3,
                NumberOfPax: 1,
                FlightPrice: {
                    Amount: 66,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 97,
                    Currency,
                },
                BookingFee: {
                    Amount: 0,
                    Currency,
                },
                TotalPrice: {
                    Amount: 163,
                    Currency,
                },
            },
        ],
        RebookableFee: {
            Amount: 0,
            Currency,
        },
    },
    RebookablePriceBreakdown: {
        FareTypes: [
            {
                FareType: 1,
                NumberOfPax: 2,
                FlightPrice: {
                    Amount: 651.60064166666666666666666667,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 1238,
                    Currency,
                },
                BookingFee: {
                    Amount: -28.600641666666666666666666667,
                    Currency,
                },
                TotalPrice: {
                    Amount: 1861,
                    Currency,
                },
            },
            {
                FareType: 2,
                NumberOfPax: 1,
                FlightPrice: {
                    Amount: 484.60064166666666666666666667,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 1238,
                    Currency,
                },
                BookingFee: {
                    Amount: -28.600641666666666666666666667,
                    Currency,
                },
                TotalPrice: {
                    Amount: 1694,
                    Currency,
                },
            },
            {
                FareType: 3,
                NumberOfPax: 1,
                FlightPrice: {
                    Amount: 66,
                    Currency,
                },
                TaxesAndFees: {
                    Amount: 97,
                    Currency,
                },
                BookingFee: {
                    Amount: 0,
                    Currency,
                },
                TotalPrice: {
                    Amount: 163,
                    Currency,
                },
            },
        ],
        RebookableFee: {
            Amount: 899.0,
            Currency,
        },
    },
    PaymentDiscount: {
        Amount: 199.0,
        Currency,
    },
    PaymentDiscountMethodName: 'Trustly',
};
export const fakeItineraryData: ItineraryBookData = OneSegmentWithOneStop;
